/**
 * Attributes for the NavPortalMenuItem component
 */
export interface NavPortalMenuItemAttributes {
  /** Navigation URL for the menu item */
  href?: string
  /** Text label displayed next to the icon */
  label?: string
  /** Bootstrap icon name to display */
  icon?: string
  /** Whether this menu item represents the current page */
  active?: boolean
  /** Link target (e.g., '_blank' for new tab) */
  target?: '_blank' | '_self' | '_parent' | '_top' | string
  /** Optional ARIA label for screen readers */
  'aria-label'?: string
}

/**
 * Attribute name constants
 */
export const NavPortalMenuItemAttr = {
  HREF: 'href',
  LABEL: 'label',
  ICON: 'icon',
  ACTIVE: 'active',
  TARGET: 'target',
  ARIA_LABEL: 'aria-label',
  ARIA_CURRENT: 'aria-current',
  ARIA_HIDDEN: 'aria-hidden',
  REL: 'rel',
  NAME: 'name',
  EXPANDABLE: 'expandable',
} as const

/**
 * CSS class name constants
 */
export const NavPortalMenuItemClass = {
  MENU_ITEM: 'nav-portal-menu-item',
  LABEL: 'nav-label',
  ACTIVE: 'active',
} as const

/**
 * Default values
 */
export const NavPortalMenuItemDefaults = {
  HREF: '#',
  LABEL: '',
  ICON: 'house',
} as const

/**
 * Link target values
 */
export const NavPortalMenuItemTarget = {
  BLANK: '_blank',
  SELF: '_self',
  PARENT: '_parent',
  TOP: '_top',
} as const

/**
 * Security and accessibility values
 */
export const NavPortalMenuItemValues = {
  REL_NOOPENER: 'noopener noreferrer',
  ARIA_CURRENT_PAGE: 'page',
  ARIA_CURRENT_FALSE: 'false',
  ARIA_HIDDEN_TRUE: 'true',
} as const

/**
 * Query selectors (excluding component selector)
 */
export const NavPortalMenuItemSelector = {
  ANCHOR: 'a',
  ICON: 'wa-icon',
  LABEL: '.nav-label',
} as const
